import { v4 as uuidv4 } from 'uuid'
import JobTypes from '../helpers/JobTypesEnum'
import { STORAGE_PATH } from '../config'

const mexa = {
  id: uuidv4(),
  name: 'Mexa',
  path: '/mexa',
  bios: [
    'Coletivo formado por pessoas em situação de vulnerabilidade e por membros da comunidade LGBTQIA+ que, a partir de derivas, performances, fotografias, vídeos, músicas, escritas e protestos, criam obras limítrofes, que não se encaixam em categorias precisas. O grupo realiza ações que transitam entre a arte e a política, assumindo lugares de fala e de falha de conceitos que procuram enquadrar corpos e estéticas.',
    'Collective composed of people in situations of vulnerability and members of the LGBTQIA+ community who, based on drifts, performances, photos, videos, music, writings and protests, create borderline works that do not fit into precise categories. The group performs actions that transit between art and politics, while assuming places of speech and concepts failures that seek to frame bodies and aesthetics.'
  ],
  jobs: [
    {
      id: uuidv4(),
      title: 'Especial ano novo',
      type: JobTypes.AUDIO,
      path: '/especial-fim-de-ano',
      image: '/assets/mexa/especial-ano-novo-du-vida-nova.png',
      imageHover: '/assets/mexa/especial-ano-novo-du-vida-nova_hover.png',
      texts: [
        'Duas faixas para este momento de deixar para trás o que passou; lado A e lado B de uma mesma carta de intenções para o que vem. "E você, o que fez? Já é 2021, mas seguiremos presas no ano passado?!"',
        `Two tracks for this moment of leaving behind what has passed; A-side and B-side of a letter of intent for whatever comes. "And you, what have you done? It's already 2021, but will we be stuck in last year?!"`,
      ],
      pages: [
        {
          id: uuidv4(),
          link: 'Lado A',
          title: 'Ivana Siqueira - À Distância',
          src: `${STORAGE_PATH}/MEXA/2.+Especial+de+Fim+de+Ano_/Ivana+Siqueira+-+À+Distância.wav`,
          path: '/a-distancia',
        },
        {
          id: uuidv4(),
          link: 'Lado B',
          title: 'Tatyane Dell Campobello - Então é Natal',
          src: `${STORAGE_PATH}/MEXA/2.+Especial+de+Fim+de+Ano_/Tatyane+Dell+Campobello+-+Então+é+Natal.wav`,
          path: '/entao-e-natal',
        }
      ]
    },
    {
      id: uuidv4(),
      title: 'Só Anitta pode add',
      type: JobTypes.WHATSAPP,
      path: '/so-anitta-pode-add',
      image: '/assets/mexa/so-anitta-pode-add.png',
      imageHover: '/assets/mexa/so-anitta-pode-add_hover.png',
      texts: [
        'Uma compilação de áudios esquecidos em celulares desaparecidos.',
        'A compilation of forgotten audios on missing cell phones.',
      ],
      pages: [
        {
          id: uuidv4(),
          link: '',
          path: '/play',
        },
      ]
    }
  ],
}

console.log(...mexa.jobs[0].pages.map((p) => p.src))
export default mexa
